import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import GuidePage from "../pages/article/page";
import BestDealsPage from "../pages/articles/BestDealsPage";
import VsTraditionalPage from "../pages/articles/VsTraditionalPage";
import CategoryGuidePage from "../pages/articles/CategoryGuidePage";
import TipsTricksPage from "../pages/articles/TipsTricksPage";
import EuropeanShoppersPage from "../pages/articles/EuropeanShoppersPage";
import PriceTrackingPage from "../pages/articles/PriceTrackingPage";
import BeginnersGuidePage from "../pages/articles/BeginnersGuidePage";
import SafetySecurityPage from "../pages/articles/SafetySecurityPage";
import Updates2026Page from "../pages/articles/Updates2026Page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/mulebuy-spreadsheet-guide-2026",
    element: <GuidePage />,
  },
  {
    path: "/mulebuy-spreadsheet-best-deals-2026",
    element: <BestDealsPage />,
  },
  {
    path: "/mulebuy-spreadsheet-vs-traditional-shopping",
    element: <VsTraditionalPage />,
  },
  {
    path: "/mulebuy-spreadsheet-category-guide",
    element: <CategoryGuidePage />,
  },
  {
    path: "/mulebuy-spreadsheet-tips-tricks-2026",
    element: <TipsTricksPage />,
  },
  {
    path: "/mulebuy-spreadsheet-european-shoppers",
    element: <EuropeanShoppersPage />,
  },
  {
    path: "/mulebuy-spreadsheet-price-tracking",
    element: <PriceTrackingPage />,
  },
  {
    path: "/mulebuy-spreadsheet-beginners-guide",
    element: <BeginnersGuidePage />,
  },
  {
    path: "/mulebuy-spreadsheet-safety-security",
    element: <SafetySecurityPage />,
  },
  {
    path: "/mulebuy-spreadsheet-2026-updates",
    element: <Updates2026Page />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;